import { createAsyncAction } from 'typesafe-actions'
import { ICutoffTime } from '../../../api'

export const FETCH_TOMORROWS_CUTOFF = createAsyncAction(
  'order/FETCH_TOMORROWS_CUTOFF',
  'order/FETCH_TOMORROWS_CUTOFF_SUCCESS',
  'order/FETCH_TOMORROWS_CUTOFF_FAILURE',
  'order/FETCH_TOMORROWS_CUTOFF_CANCEL',
)<undefined, ICutoffTime, Error, undefined>()
